<template>
	<div class="agency-project-name">
		<v-layout row>
			<h1>Projekt ({{ value }})</h1>
		</v-layout>
		<br>
	</div>
</template>

<script>
	export default {
		name: "AgencyProjectName",

		props: {
			value: {},
		},
	};
</script>

<style scoped>
	.agency-project-name h1 {
		margin-left: 20px;

	}
</style>
